export default {"src":"/_next/static/media/english.f88c6031.svg","height":26,"width":36};